export default {
  ON_BOARDING_RENEW_VERIFY_NIP_REPOSITORY:
    Symbol.for('ON_BOARDING_RENEW_VERIFY_NIP_REPOSITORY'),
  RENEW_ON_BOARDING_VERIFY_NIP_COMMAND:
    Symbol.for('RENEW_ON_BOARDING_VERIFY_NIP_COMMAND'),
};
